import { mapActions, mapGetters } from 'vuex'
import { eventBus } from '@/main'

export default {
    data() {
        return {
            localSettings: {
                keyValuePairs: [],
            },
            isSiteAvailable: true,
            maintenanceDetails: null,
            currentDocumentProcessingDate: new Date(),
        }
    },
    computed: {
        ...mapGetters({
            localSettingsReceived: 'localSettings/LocalSettings',
        }),
    },
    methods: {
        ...mapActions({
            FetchLocalSettings: 'localSettings/FetchLocalSettings',
        }),
        GetLocalSetting(key) { return this.localSettings?.keyValuePairs[key] ?? null; },
        LoadLocalSettings() {
            eventBus.$emit('local-settings-fetch:started');
            this.FetchLocalSettings()
                .then(() => {
                    if (this.localSettingsReceived != null) {
                        this.localSettings = this.localSettingsReceived;

                        this.isSiteAvailable = this.GetLocalSetting('IsSiteAvailable');
                        this.maintenanceDetails = this.GetLocalSetting('MaintenanceDetails');
                        this.currentDocumentProcessingDate = this.GetLocalSetting('CurrentDocumentProcessingDate');
                    }
                    else {
                        this.localSettings = {
                            academicSession: academicSession,
                            keyValuePairs: [],
                        };

                        this.isSiteAvailable = true;
                        this.maintenanceDetails = null;
                        this.currentDocumentProcessingDate = new Date();
                    }
                    eventBus.$emit('local-settings-fetch:success');
                })
                .catch(error => eventBus.$emit('console:error', error))
                .finally(() => eventBus.$emit('local-settings-fetch:finished'));
        },
    },
};